import React, { createContext, useContext, useEffect, useState } from "react";
import "./App.css";
import Dashboard from "./pages/Dashboard";
import LoginPage from "./pages/LoginPage";
import CreateAccountPage from "./pages/CreateAccountPage";
import Home from "./pages/Home";
import TasksPage from "./pages/TasksPage";
import TaskDetails from "./pages/TaskDetails";
import TeamsPage from "./pages/Teams/TeamsPage";
import TeamDashboard from "./pages/Teams/TeamDashboard";
import TeamTasksPage from "./pages/Teams/TeamTasksPage";
import ClientsPage from "./pages/ClientsPage";
import Profile from "./pages/Profile";
import TeamClientsPage from "./pages/Teams/TeamClientsPage";
import Settings from "./pages/Settings";
import { Route, Routes, Navigate } from "react-router-dom";
import { UserProvider } from "./components/accounts/UserProvider";
import { useLocation } from "react-router-dom";

export const AuthContext = createContext({
  isAuthenticated: false,
  setIsAuthenticated: () => {},
  redirectLink: "/",
  setRedirectLink: () => {},
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [redirectLink, setRedirectLink] = useState("/");

  const validateToken = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/validate-token`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        setIsAuthenticated(true);
      }
    } catch (error) {
      console.error("Error validating token:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    validateToken();
  }, []);

  if (isLoading) {
    return (
      <div className="flex-center-center fullscreen page-frame">
        <div className="page-content w100">
          <h1 className="loading-msg">Chargement...</h1>
        </div>
      </div>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        redirectLink,
        setRedirectLink,
      }}
    >
      <UserProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<CreateAccountPage />} />
          <Route
            path="/dashboard"
            element={<ProtectedRoute component={Dashboard} />}
          />
          <Route
            path="/active-tasks"
            element={<ProtectedRoute component={TasksPage} />}
          />
          <Route
            path="/tasks/:id/:isTeam"
            element={<ProtectedRoute component={TaskDetails} />}
          />
          <Route
            path="/join-team/:teamCode"
            element={<ProtectedRoute component={TeamsPage} />}
          />
          <Route
            path="/teams"
            element={<ProtectedRoute component={TeamsPage} />}
          />
          <Route
            path="/team/:teamId"
            element={<ProtectedRoute component={TeamDashboard} />}
          />
          <Route
            path="/team-tasks/:teamId"
            element={<ProtectedRoute component={TeamTasksPage} />}
          />
          <Route
            path="/team-clients/:teamId"
            element={<ProtectedRoute component={TeamClientsPage} />}
          />
          <Route
            path="/clients"
            element={<ProtectedRoute component={ClientsPage} />}
          />
          <Route
            path="/profile"
            element={<ProtectedRoute component={Profile} />}
          />
          <Route
            path="/settings"
            element={<ProtectedRoute component={Settings} />}
          />
        </Routes>
      </UserProvider>
    </AuthContext.Provider>
  );
}

function ProtectedRoute({ component: Component }) {
  const { isAuthenticated, setRedirectLink } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthenticated) {
    setRedirectLink(location.pathname);
    return <Navigate to="/login" />;
  }

  return <Component />;
}

export default App;
